module.exports = __webpack_public_path__ + "static/media/triangle.cfb0f4b1.svg";